var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-block"},[(_vm.context)?_c('blog-context',{attrs:{"rules":_vm.context},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var inContext = ref.inContext;
return [(inContext)?_vm._t("default"):_vm._e()]}}],null,true)}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }